export default __webpack_public_path__ + "images/455d78e9c6e6d4d25a8334cc6774eacc-auto.webp";